import './IndicatorWithTooltipInfo.css';

import React, { useEffect } from 'react';
import { Close, InfoOutlined } from '@mui/icons-material';
import { generateClassName } from '../../b2b-common/helpers';
import { getIconWithTooltip } from '../../b2b-plans/components/helper';
import { Box } from '@mui/material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import { IndicatorDetails } from '../../b2b-plans/components/area-indicators/AreaIndicatorCard';
import InfoWindow from '../../b2b-common/InfoWindow';

const IndicatorWithTooltipInfo = ({ indicator, className = null }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    const [isInfoOpen, setIsInfoOpen] = React.useState(false);
    const secondsOpen = 10;

    useEffect(() => {
        let timer;
        if (isInfoOpen) {
            timer = setTimeout(() => {
                setIsInfoOpen(false);
            }, secondsOpen * 1000);
        }
        return () => clearTimeout(timer);
    }, [isInfoOpen]);

    const handleClickOnMoreInfo = () => {
        if (isInfoOpen) {
            setIsInfoOpen(false);
            return;
        }
        setIsInfoOpen(true);
    };

    const handleCloseInfo = () => {
        setIsInfoOpen(false);
    };

    return (
        <Box className={generateClassName('indicator-with-tooltip-info', '', className)}
            boxSizing='border-box' pl='10px' pr='10px' width='100%' display='flex' justifyContent='space-between' alignItems='center'
            position='relative'
        >
            <Box className='indicator-with-tooltip-info-name'
                whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' color='rgb(75,75,75)'
            >
                {indicator.indicatorName}
            </Box>
            {getIconWithTooltip(InfoOutlined, {}, t('Click for more information on the indicator used'), null, handleClickOnMoreInfo)}
            {isInfoOpen && (
                <InfoWindow
                    top='30px' right='30px'
                    width='90%' minHeight='100px'
                    windowTitle={t('Indicator used details:')}
                    windowContent={<IndicatorDetails indicator={indicator} />}
                    handleClose={handleCloseInfo}
                    className='indicator-with-tooltip-info-information-window'
                    secondsOpen={secondsOpen}
                />
            )}
            {/* <Box className='indicator-with-tooltip-info-information-window'
                position='absolute' zIndex='100' top='30px' left='30px' display={isInfoOpen ? 'block' : 'none'}
                width='90%' height='100px' backgroundColor='#fbfbffea' color='white' borderRadius='8px'
                boxShadow={5}
            >
                <Box className='indicator-with-tooltip-info-information-window-content'
                    display='flex' flexDirection='column' justifyContent='center' alignItems='center' position={'relative'}
                    width='100%' height='100%' padding='10px' boxSizing='border-box'
                >
                    <IndicatorDetails indicator={indicator} />
                    {getIconWithTooltip(Close, { cursor: 'pointer', position: 'absolute', top: '10px', right: '10px', color: '#011d89' }, t('Close'), null, handleCloseInfo)}                    
                </Box>                
            </Box> */}
        </Box>
    );
};

export default IndicatorWithTooltipInfo;